<template>
  <com-page>
    <com-card>
      <div class="mb-15px">
        <h3 v-if="isEdit">编辑套餐卡</h3>
        <h3 v-else>创建套餐卡</h3>
      </div>
      <div class="edit_wrapper">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px">
          <el-form-item label="套餐卡名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入套餐卡名称"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="功率上限" prop="limitMaxPower">
            <el-input
              v-model="ruleForm.limitMaxPower"
              placeholder="请输入功率上限"
              style="width: 500px"
            >
              <template slot="append">W</template>
            </el-input>
          </el-form-item>
          <el-form-item label="套餐卡类型" required>
            <div class="package-type-list">
              <div
                class="package-type-item"
                :class="{ active: item.selected }"
                v-for="(item, index) in packageTypes"
                :key="index"
                @click="handleSelectType(item)"
              >
                {{ item.label }}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="月卡" v-if="selectTypes.includes(1)">
            <el-button size="mini" type="primary" @click="addMonthCard">添加</el-button>
            <el-table :data="ruleForm.monthPlanList" style="width: 50%">
              <el-table-column prop="planName" label="套餐名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.planName" placeholder="请输入" />
                </template>
              </el-table-column>
              <el-table-column prop="minute" label="套餐时长">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.minute" placeholder="请输入">
                    <template slot="append">小时</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="价格">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.money" placeholder="请输入">
                    <template slot="append">元</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="ruleForm.monthPlanList.splice(scope.$index, 1)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="季卡" v-if="selectTypes.includes(2)">
            <el-button size="mini" type="primary" @click="addSeasonCard">添加</el-button>
            <el-table :data="ruleForm.seasonPlanList" style="width: 50%">
              <el-table-column prop="planName" label="套餐名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.planName" placeholder="请输入" />
                </template>
              </el-table-column>
              <el-table-column prop="minute" label="套餐时长">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.minute" placeholder="请输入">
                    <template slot="append">小时</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="价格">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.money" placeholder="请输入">
                    <template slot="append">元</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="ruleForm.seasonPlanList.splice(scope.$index, 1)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="年卡" v-if="selectTypes.includes(3)">
            <el-button size="mini" type="primary" @click="addYearCard">添加</el-button>
            <el-table :data="ruleForm.yearPlanList" style="width: 50%">
              <el-table-column prop="planName" label="套餐名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.planName" placeholder="请输入" />
                </template>
              </el-table-column>
              <el-table-column prop="minute" label="套餐时长">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.minute" placeholder="请输入">
                    <template slot="append">小时</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="价格">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.money" placeholder="请输入">
                    <template slot="append">元</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="ruleForm.yearPlanList.splice(scope.$index, 1)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="关联小区">
            <el-select
              v-model="communitySelectCode"
              placeholder="请搜索对应小区进行关联"
              clearable
              remote
              :remote-method="getCommunityList"
              filterable
              :loading="communityLoading"
              @change="handleSelectCommunity"
              style="width: 500px"
            >
              <el-option
                :label="item.name + `(社区编号:${item.number})`"
                :value="item.code"
                v-for="item in communityList"
                :key="item.code"
              ></el-option>
            </el-select>
            <el-table :data="ruleForm.residentialAreaBeanList" style="width: 50%; margin-top: 20px">
              <el-table-column prop="refResidentailAreaName" label="小区名称"></el-table-column>
              <el-table-column prop="number" label="社区编号"></el-table-column>
              <el-table-column prop="name" label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="ruleForm.residentialAreaBeanList.splice(scope.$index, 1)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <div class="flex justify-end">
            <el-button @click="$router.back()">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="disabled"
              >确认</el-button
            >
          </div>
          <el-form-item> </el-form-item>
        </el-form>
      </div>
    </com-card>
  </com-page>
</template>

<script>
import { communityListApi } from '@/api/community'
import { monthCardDetailApi, addMonthCardApi, updateMonthCardApi } from '@/api/package-card'

import utils from 'my-tools-library'

const COMMUNITY_SEARCH_PAGE_SIZE = 50

export default {
  data() {
    return {
      id: '',
      isEdit: false,
      disabled: false,
      selectTypes: [],
      communitySelectCode: '',
      ruleForm: {
        code: '',
        name: '',
        limitMaxPower: '',
        residentialAreaBeanList: [],
        monthPlanList: [],
        seasonPlanList: [],
        yearPlanList: []
      },
      rules: {
        name: [{ required: true, message: '请输入套餐卡名称', trigger: 'blur' }],
        limitMaxPower: [{ required: true, message: '请输入功率上限', trigger: 'blur' }]
      },
      packageTypes: [
        { label: '月卡', value: 1, selected: false },
        { label: '季卡', value: 2, selected: false },
        { label: '年卡', value: 3, selected: false }
      ],
      monthCards: [{}],
      seasonCards: [{}],
      yearCards: [{}],
      communityList: [],
      communityLoading: false,
      packageTypeIndex: 0,
      defaultPlanParams: {
        planName: '',
        minute: '',
        money: ''
      }
    }
  },

  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.isEdit = true
      this.getDetail()
    }
  },

  methods: {
    // 获取套餐卡详情
    getDetail() {
      monthCardDetailApi({ code: this.id }).then((res) => {
        this.detail = res.data.monthCard
        Object.keys(this.ruleForm).forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(this.detail, key)) {
            this.ruleForm[key] = this.detail[key]
          }
        })
        const residentialAreaBeanList = this.detail.residentialAreaBeanList || []
        this.ruleForm.residentialAreaBeanList = residentialAreaBeanList.map((item) => ({
          code: item.code,
          refResidentailArea: item.refResidentailArea,
          refResidentailAreaName: item.refResidentailAreaName,
          number: item.refResidentialAreaNumber || item.number
        }))
        this.selectTypes = this.detail.monthCardDurationTypeList || []
        // 回显套餐类型
        this.packageTypes.forEach((item) => {
          if (this.selectTypes.includes(item.value)) {
            item.selected = true
          }
        })
      })
    },
    // 获取小区列表
    getCommunityList(value) {
      const name = value && value.trim ? value.trim() : value
      if (!name) {
        this.communityList = []
        return
      }
      const params = {
        pageIndex: 1,
        pageSize: COMMUNITY_SEARCH_PAGE_SIZE,
        name
      }
      this.communityLoading = true
      communityListApi(params)
        .then((res) => {
          const { records } = res.data
          this.communityList = records || []
          this.communityLoading = false
        })
        .catch(() => {
          this.communityList = []
          this.communityLoading = false
        })
    },
    // 添加月卡
    addMonthCard() {
      this.ruleForm.monthPlanList.push({
        ...this.defaultPlanParams,
        durationType: 1 // 月卡
      })
    },
    // 添加季卡
    addSeasonCard() {
      this.ruleForm.seasonPlanList.push({
        ...this.defaultPlanParams,
        durationType: 2 // 季卡
      })
    },
    // 添加年卡
    addYearCard() {
      this.ruleForm.yearPlanList.push({
        ...this.defaultPlanParams,
        durationType: 3 // 年卡
      })
    },
    // 选中卡类型
    handleSelectType(item) {
      item.selected = !item.selected
      this.selectTypes = this.packageTypes
        .filter((typeItem) => typeItem.selected)
        .map((typeItem) => typeItem.value)
      if (this.selectTypes.indexOf(1) === -1) this.ruleForm.monthPlanList = []
      if (this.selectTypes.indexOf(2) === -1) this.ruleForm.seasonPlanList = []
      if (this.selectTypes.indexOf(3) === -1) this.ruleForm.yearPlanList = []
    },
    // 获取选中小区
    handleSelectCommunity(code) {
      if (!code) return
      const community = this.communityList.find((item) => item.code === code)
      this.communitySelectCode = ''

      if (!community) {
        this.$message.warning('未找到选中的小区，请重新搜索')
        return
      }
      if (this.ruleForm.residentialAreaBeanList.some((item) => item.refResidentailArea === code)) {
        this.$message.warning('该小区已关联')
        return
      }

      this.ruleForm.residentialAreaBeanList.push({
        refResidentailArea: community.code,
        refResidentailAreaName: community.name,
        number: community.number
      })
    },
    submitParams() {
      if (!this.selectTypes.length) return this.$message.error('请选择套餐卡类型')
      const params = utils.deepCopy(this.ruleForm)

      // 关联小区只提交后端保存需要的字段，保留 code 用于编辑时识别已有绑定。
      params.residentialAreaBeanList = (params.residentialAreaBeanList || []).map((item) => ({
        code: item.code,
        refResidentailArea: item.refResidentailArea,
        refResidentailAreaName: item.refResidentailAreaName
      }))

      return utils.cleanObject(params)
    },
    handleCreated() {
      this.disabled = true
      addMonthCardApi(this.submitParams())
        .then(() => {
          this.disabled = false
          this.$router.back()
        })
        .catch(() => {
          this.disabled = false
        })
    },
    handleUpdate() {
      this.disabled = true
      updateMonthCardApi(this.submitParams())
        .then(() => {
          this.$message.success('编辑成功')
          this.disabled = false
        })
        .catch(() => {
          this.disabled = false
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return
        }
        if (!this.ruleForm.residentialAreaBeanList.length) {
          this.$message.error('请选择关联小区')
          return
        }
        if (this.isEdit) {
          this.handleUpdate()
        } else {
          this.handleCreated()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.edit_wrapper {
  .package-type-list {
    display: flex;
    align-items: center;
    .package-type-item {
      padding: 0 30px;
      border: 1px solid #eaeaea;
      border-radius: 8px;
      margin-right: 20px;
      cursor: pointer;
      &.active {
        background-color: #006fff;
        border: 1px solid #006fff;
        color: #fff;
      }
    }
  }
}
</style>
